import axios, { CancelTokenSource } from 'axios';

import { Product } from '../../entities/Product';
import { ProductData } from './types/ProductData';

const ENPOINTS: { [name: string]: string } = {
    ProductList: '/rest/products',
};

export class API {
    private static cancelTokenSources: CancelTokenSource[] = [];

    public static generateCancelSource(): CancelTokenSource {
        const source = axios.CancelToken.source();

        API.cancelTokenSources.push(source);

        return source;
    }

    public static async findProducts(search: string): Promise<Product[]> {
        const cancelTokenSource = API.cancelTokenSources.pop();

        const response = await axios.get<ProductData[]>(ENPOINTS.ProductList, {
            params: {
                title: search,
                desc: search,
            },
            cancelToken: cancelTokenSource?.token,
        });

        return response.data.map((r: ProductData) => new Product(r));
    }
}
